import { render, staticRenderFns } from "./CrewBasicInfoForm.vue?vue&type=template&id=3a41657f&scoped=true"
import script from "./CrewBasicInfoForm.vue?vue&type=script&lang=js"
export * from "./CrewBasicInfoForm.vue?vue&type=script&lang=js"
import style0 from "./CrewBasicInfoForm.vue?vue&type=style&index=0&id=3a41657f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a41657f",
  null
  
)

export default component.exports